import { notificationUnreadCountQueryAtom } from '~/modules/notifications/_graphql/queryNotificationUnreadCount';

export const $notificationUnreadCount = notificationUnreadCountQueryAtom();

$notificationUnreadCount.debugLabel = '$notifications.unreadCount';
